import { defineStore } from "pinia";

export const useRecruitmentPlanningStore = defineStore('recruitmentPlanning', {
  state: () => ({
    recruitmentPlanning: {},
    recruitmentPlannings: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setRecruitmentPlanning(recruitmentPlanning) {
      this.recruitmentPlanning = recruitmentPlanning
    },
    setRecruitmentPlannings(recruitmentPlannings) {
      this.recruitmentPlannings = recruitmentPlannings
    },
    addRecruitmentPlanning(recruitmentPlanning) {
      this.recruitmentPlannings.unshift(recruitmentPlanning)
    },
    updateRecruitmentPlanning(recruitmentPlanning) {
      let index = this.recruitmentPlannings.findIndex(cl => cl.id === recruitmentPlanning.id)
      this.recruitmentPlannings.splice(index, 1, recruitmentPlanning)
    },
    deleteRecruitmentPlanning(recruitmentPlanning) {
      let index = this.recruitmentPlannings.findIndex(cl => cl.id === recruitmentPlanning.id)
      this.recruitmentPlannings.splice(index, 1)
    },
  },
});